import { useEffect, useState } from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://bosp-yachts-backend.vercel.app';
const ENDPOINT = `${BACKEND_URL}/api/calendar/connected-yachts`;

// One request per page load, shared by every card on the page. Cards mount in
// bulk on the listing pages, so without this each one would hit the API.
let cachedIds = null;
let inflight = null;

const loadConnectedYachtIds = () => {
  if (cachedIds) return Promise.resolve(cachedIds);
  if (!inflight) {
    inflight = fetch(ENDPOINT)
      .then(response => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return response.json();
      })
      .then(data => {
        cachedIds = new Set(data.yachtIds || []);
        return cachedIds;
      })
      .catch(error => {
        console.error('Error loading connected yacht calendars:', error);
        inflight = null; // allow a retry on the next mount
        return new Set();
      });
  }
  return inflight;
};

/**
 * Returns the set of yacht IDs whose Google Calendar is connected, i.e. the
 * yachts that can be booked instantly. Empty until loaded.
 */
const useConnectedCalendars = () => {
  const [connectedIds, setConnectedIds] = useState(() => cachedIds || new Set());

  useEffect(() => {
    let active = true;
    loadConnectedYachtIds().then(ids => {
      if (active) setConnectedIds(ids);
    });
    return () => { active = false; };
  }, []);

  return connectedIds;
};

export default useConnectedCalendars;
